import React from "react";
import axios, {AxiosPromise, AxiosResponse, GenericFormData, ResponseType } from "axios";
import FormData from "form-data";
import https from "https";
import { NavLink, NavigateFunction } from "react-router-dom";
import { ResponseParamBase } from "./Types";
import { ApiUrl } from "./Params"

const apiName: string | undefined = process.env.REACT_APP_API_NAME;
const host: string | undefined = process.env.REACT_APP_API_HOST;
const port: string | undefined = process.env.REACT_APP_API_PORT;
export const baseFrontAppUrl = window.location.protocol + "//" + host;
export const baseUrl = window.location.protocol + "//" + host + port  + apiName;//"http://localhost:8000/clickeracehelpchat";//"http://localhost:8000/backend";
const tokenUrl = baseUrl + ApiUrl.Login;//"http://localhost:8000/clickeracehelpchat/auth/token/"//"http://localhost:8000/api/token/";
const refreshUrl = baseUrl + ApiUrl.RefreshToken;//"http://localhost:8000/clickeracehelpchat/auth/token/refresh/"//"http://localhost:8000/api/token/refresh/";

export type ResponseResultParam = {
    resultFlg: boolean,
    message: string
}

export type RefreshToken = ResponseParamBase & {
    AccessToken: string,
    RefreshToken: string,
    jwtToken: string,
}

export type TokenResponse = {
    access: string,
    refresh: string,
}

export type RefreshTokenResponse = {
    access: string,
}

export function JumpPage<T>(path: string, param: T, navigate: NavigateFunction){
    navigate(path, {state: param});
}

export function CreateFileListFromBlobObject(file: Blob, fileName: string = "temp") : FileList | null{
    const dt = new DataTransfer();
    dt.items.add(new File([file], fileName, { type: file.type }));
    return dt.files;
}

export function HttpPostData<T>(path: string, param: Object, isLoading: React.Dispatch<React.SetStateAction<boolean>> | null): AxiosPromise<T> {
    /*
     * "Access-Control-Allow-Origin": window.location.origin,
                "Access-Control-Allow-Methods": "POST,GET,PUT,DELETE",
                "Access-Control-Allow-Headers": "Content-Type",
     **/
    
        axios.defaults.baseURL = baseUrl;//window.location.protocol + "//" + window.location.host + apiName;
        axios.defaults.withCredentials = true
        axios.defaults.xsrfCookieName = 'XCSRF-TOKEN';
        axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
        const createaxios = axios.create({
            headers: {
                "Content-Type": "application/json",            
                "Authorization": `Bearer ${window.localStorage.getItem('clickeracejwttoken')}` ,
            },
            responseType: "json",
        });
        let isRetry = false;
    
        createaxios.interceptors.request.use(config => {
            if (isLoading != null) isLoading(true);
            return config;
        });
    
        createaxios.interceptors.response.use(
            response => {
                //成功時はレスポンスを返す            
                return response;
            },
            async function (error) {
                //エラー時
                const originalRequest = error.config;
                if (error.response.status === 401 && !isRetry) {
                    isRetry = true;
                    return await createaxios.post<TokenResponse>("/authenticate/refresh-token-cookie",
                        {
                        }
                    )
                        .then(res => {
                            if (res.status === 200) {
                                return createaxios(originalRequest);
                            }
                        })
                        .catch(() => {
                            return Promise.reject(error);
                        });
                } else {
                    //認証以外のエラーで失敗した場合
                    return Promise.reject(error);
                }
            }
        );
        return createaxios.post(path, param).finally(() => {
            isLoading?.(false);
        });
    }

    export async function UploadFile<T>(path: string, param: {[key: string]: any} , isLoading: React.Dispatch<React.SetStateAction<boolean>> | null, responseType: ResponseType = "json"):  Promise<AxiosResponse<T, any>> {
        const csrftoken = await getCsrfToken();
        //param['csrfmiddlewaretoken'] = csrftoken;

        axios.defaults.baseURL = baseUrl;
        axios.defaults.withCredentials = true
        axios.defaults.xsrfCookieName = 'XCSRF-TOKEN';
        axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
        //const fdata = new FormData(param);
        const fdata: GenericFormData = axios.toFormData(param);
        const createaxios = axios.create({
            headers: {
                "Access-Control-Allow-Origin": host,
                "Access-Control-Allow-Credentials": "true",
                "Content-Type": "multipart/form-data",
                "Authorization": `JWT ${window.localStorage.getItem('accesstoken')}` ,
                'X-CSRFToken': csrftoken,
            },
            responseType: responseType,
            //httpsAgent: new https.Agent({rejectUnauthorized: false}),
        });
        let isRetry = false;
    
        createaxios.interceptors.request.use(config => {
            isLoading?.(true);
            return config;
        });
    
        createaxios.interceptors.response.use(
            response => {
                //成功時はレスポンスを返す            
                return response;
            },
            async function (error) {
                //エラー時
                const originalRequest = error.config;
                const refreshAxios = axios.create({
                    headers: {
                        "Content-Type": "application/json"
                    },
                    responseType: "json",
                    baseURL: refreshUrl,
                    //httpsAgent: new https.Agent({rejectUnauthorized: false}),
                });
                //alert(`errorcode:${error.response.status}`);
                if (error.response.status === 401 && !isRetry) {
                    isRetry = true;
                    
                    return await refreshAxios.post<RefreshTokenResponse>(refreshUrl,
                        {
                            "refresh": window.localStorage.getItem('refreshtoken')
                        }
                    )
                        .then(async res => {
                            if (res.status === 200) {
                                
                                //alert(`newcode:${res.data.access}`);
                                window.localStorage.setItem('accesstoken', res.data.access)
                                //return createaxios(originalRequest);
                                const retryAxios = axios.create({
                                    headers: {
                                        "Content-Type": "multipart/form-data",            
                                        "Authorization": `JWT ${window.localStorage.getItem('accesstoken')}` ,
                                        'X-CSRFToken': csrftoken,
                                    },
                                    responseType: responseType,
                                    //httpsAgent: new https.Agent({rejectUnauthorized: false}),
                                });
                                return await retryAxios.post<T>(
                                    path,
                                    fdata,
                                ).finally(() => {isLoading?.(false)});
                            }
                        })
                        .catch(() => {
                            return Promise.reject(error);
                        });
                } else {
                    //認証以外のエラーで失敗した場合
                    return Promise.reject(error);
                }
            }
        );
        
        //console.log(fdata);
        //alert(`basepost:${localStorage.getItem('accesstoken')}`);
        return await createaxios.post<T>(
            path,
            fdata,
            /*{
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `JWT ${window.localStorage.getItem('accesstoken')}` ,
                    'X-CSRFToken': xx
                },
            }*/
        ).finally(() => {
            isLoading?.(false);
        });
    }

    export async function UploadFile2<T>(path: string, param: {[key: string]: any} , isLoading: React.Dispatch<React.SetStateAction<boolean>> | null, responseType: ResponseType = "json"):  Promise<AxiosResponse<T, any>> {
        const csrftoken = await getCsrfToken();
        param['csrfmiddlewaretoken'] = csrftoken;//csrfmiddlewaretoken
        axios.defaults.baseURL = baseUrl;
        axios.defaults.withCredentials = true
        //axios.defaults.xsrfCookieName = 'XCSRF-TOKEN';
        //axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
        //const fdata = new FormData(param);
        const fdata: GenericFormData = axios.toFormData(param);
        console.log('postparam', param);
        console.log('formdata', fdata);
        
        const createaxios = axios.create({
            withCredentials: true,
            headers: {
                "Content-Type": "multipart/form-data",            
                "Authorization": `JWT ${window.localStorage.getItem('accesstoken')}` ,
                'X-CSRFToken': csrftoken,
            },
            responseType: responseType,
            //httpsAgent: new https.Agent({rejectUnauthorized: false}),
        });
        let isRetry = false;
    
        createaxios.interceptors.request.use(config => {
            isLoading?.(true);
            return config;
        });
    
        createaxios.interceptors.response.use(
            response => {
                //成功時はレスポンスを返す            
                return response;
            },
            async function (error) {
                //エラー時
                const originalRequest = error.config;
                const refreshAxios = axios.create({
                    headers: {
                        "Content-Type": "application/json"
                    },
                    responseType: "json",
                    baseURL: refreshUrl,
                    //httpsAgent: new https.Agent({rejectUnauthorized: false}),
                });
                //alert(`errorcode:${error.response.status}`);
                if (error.response.status === 401 && !isRetry) {
                    isRetry = true;
                    
                    return await refreshAxios.post<RefreshTokenResponse>(refreshUrl,
                        {
                            "refresh": window.localStorage.getItem('refreshtoken')
                        }
                    )
                        .then(async res => {
                            if (res.status === 200) {
                                
                                //alert(`newcode:${res.data.access}`);
                                window.localStorage.setItem('accesstoken', res.data.access)
                                //return createaxios(originalRequest);
                                const retryAxios = axios.create({
                                    headers: {
                                        "Content-Type": "multipart/form-data",            
                                        "Authorization": `JWT ${window.localStorage.getItem('accesstoken')}` ,
                                        'X-CSRFToken': csrftoken,
                                    },
                                    responseType: responseType,
                                    //httpsAgent: new https.Agent({rejectUnauthorized: false}),
                                });
                                return await retryAxios.post<T>(
                                    path,
                                    fdata,
                                ).finally(() => {isLoading?.(false)});
                            }
                        })
                        .catch(() => {
                            return Promise.reject(error);
                        });
                } else {
                    //認証以外のエラーで失敗した場合
                    return Promise.reject(error);
                }
            }
        );
        
        //console.log(fdata);
        //alert(`basepost:${localStorage.getItem('accesstoken')}`);
        return await createaxios.post<T>(
            path,
            fdata,
            /*{
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `JWT ${window.localStorage.getItem('accesstoken')}` ,
                    'X-CSRFToken': xx
                },
            }*/
        ).finally(() => {
            isLoading?.(false);
        });
    }

    export async function getToken<T>(username: string, password: string){
        //axios.defaults.baseURL = tokenUrl;
        //axios.defaults.withCredentials = true
        //axios.defaults.xsrfCookieName = 'XCSRF-TOKEN';
        //axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

        const createaxios = axios.create({
            baseURL: tokenUrl,
            withCredentials: true,            
            headers: {
                "Access-Control-Allow-Origin": host,
                "Access-Control-Allow-Credentials": "true",
                "Content-Type": "application/json"//"multipart/form-data",            
                //'X-CSRFToken': xx
            },
            responseType: "json",
        });
        let isRetry = false;
    
        /*createaxios.interceptors.request.use(config => {
            if (isLoading != null) isLoading(true);
            return config;
        });*/

        createaxios.interceptors.response.use(
            response => {
                //成功時はレスポンスを返す            
                return response;
            },
            async function (error) {
                //エラー時
                const originalRequest = error.config;
                if (error.response.status === 401 && !isRetry) {
                    isRetry = true;
    
                    return await createaxios.post<RefreshTokenResponse>(refreshUrl,
                        {
                            "refresh": window.localStorage.getItem('refreshtoken')
                        }
                    )
                        .then(res => {
                            if (res.status === 200) {
                                return createaxios(originalRequest);
                            }
                        })
                        .catch(() => {
                            return Promise.reject(error);
                        });
                } else {
                    //認証以外のエラーで失敗した場合
                    return Promise.reject(error);
                }
            }
        );
        const fdata: GenericFormData = axios.toFormData({'username': username, 'password': password});
        return createaxios.post<TokenResponse>('', fdata).finally(() => {
        });
    }
    
    type CsrfToken = {
        csrfToken: string,
    }

    export async function getCsrfToken() {
        /*if (_csrfToken === null) {
          const response = await fetch(`${baseUrl}/csrf`, {
            credentials: 'include',            
          });
          const data = await response.json();
          _csrfToken = data.csrfToken;
        }
        return _csrfToken;*/        
        const response = await axios.get<CsrfToken>(
            `${baseUrl}/csrf`,
            {
                withCredentials : true
            },
        )
        return response.data.csrfToken;
      }